import { alertV3Reducer } from "./alerts-v3/reducers";
import { contentFoldersReducer } from "./content-folders/reducers";
import { contentGroupsReducer } from "./content-groups/reducers";
import { deploymentsReducer } from "./deployments/reducers";
import { scheduledDeploymentsReducer } from "./scheduled-deployments/reducers";
import { strategiesReducer } from "./strategies/reducers";

type AppReducer = (state: unknown, action: unknown) => unknown;
const asAppReducer = (reducer: unknown) => reducer as AppReducer;

// Define the application store.
const appReducers: Record<string, AppReducer> = {
  alertsV3: asAppReducer(alertV3Reducer),
  contentFolders: asAppReducer(contentFoldersReducer),
  contentGroups: asAppReducer(contentGroupsReducer),
  deployments: asAppReducer(deploymentsReducer),
  scheduledDeployments: asAppReducer(scheduledDeploymentsReducer),
  strategies: asAppReducer(strategiesReducer),
};

export { appReducers };
